

import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  Select,
  Form,
  Input,
  Button,
  Row,
  Col,
  DatePicker,
  message,
  Card
} from "antd";
import { createIntimateClaimIpd, getEmployeeCode, getPatientName, getLocationDetail } from "../../Action/Actions";
import { getUserData } from "../login/LoginSlice";

const { Option } = Select;
const { TextArea } = Input;

const ClaimType = [
  { id: 1, name: "Reimbursement" },
  { id: 2, name: "Cashless" },
];

const IpdForm = ({ selectedPolicyNumber, refPolicyId ,initialEmployeeCode, initialEmployeeName }) => {
  const dispatch = useDispatch();
  const [formIPD] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const user = useSelector(getUserData);
  const [employeeCode, setEmployeeCode] = useState([]);
  const [patientName, setPatientName] = useState([]);

   const [hospitalizationDate, setHospitalizationDate] = useState(null);
 

  useEffect(() => {
    
   
    fetchEmployeeCode();
    fetchPatientName();
    formIPD.setFieldsValue({
      employee_code: initialEmployeeCode,
      patient_name: initialEmployeeName,
    });
  
  }, [selectedPolicyNumber, refPolicyId, formIPD, initialEmployeeCode, initialEmployeeName ]);

  const fetchEmployeeCode = (id) => {
    dispatch(getEmployeeCode(user?.corporate_id))
      .then((data) => {
        console.log("data", data);
        const { Corporate_Employee } = data;
        setEmployeeCode(Corporate_Employee);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchPatientName = (employee_code) => {
    dispatch(getPatientName(employee_code))
      .then((data) => {
        console.log("data", data);
        const { Corporate_Employee } = data;
        setPatientName(Corporate_Employee);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEmployeeCodeChange = (value) => {
    fetchPatientName(value);
  };

  const handleHospitalizationDateChange = (date) => {
    setHospitalizationDate(date);
    // If the selected discharge date is now before the new hospitalization date, clear it
    const dischargeDate = formIPD.getFieldValue('discharge_date');
    if (dischargeDate && date && dischargeDate.isBefore(date)) {
      formIPD.setFieldsValue({ discharge_date: null });
    }
  };

  const onFinishIPD = (values) => {
   
    setLoading(true);
    const post = {
      policy_no: selectedPolicyNumber,
      ref_policy_id: refPolicyId,
      user_id: user?.user_id,
      employee_code: values?.employee_code,
      patient_name: values?.patient_name || values?.employee_code,
      reason_claim: values?.reason_for_claim,
      estimated_amount: values?.est_report_amount,
      hospitalization_date: values?.hospitalization_date
        ? dayjs(values?.hospitalization_date).format("DD-MM-YYYY")
        : null,
      discharge_date: values?.discharge_date
        ? dayjs(values?.discharge_date).format("DD-MM-YYYY")
        : null,
      hospital_name: values?.hospital_name,
      hospital_address: values?.hospital_address,
      pincode: values?.pincode,
      city: values?.city,
      state: values?.state,
      claim_type: values?.claim_type,
      remarks: values?.remark,
      ref_corporate_id: user?.corporate_id,
      portal_type : "2"
    };
    console.log("Payload:", post); // Log the payload to verify the fields
    dispatch(createIntimateClaimIpd(post))
      .then((data) => {
        console.log("data", data);
        message.success(data?.message);
        setLoading(false);
        formIPD.resetFields();
        setHospitalizationDate(null);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
 const OnPinChange = (e) => {
      const value = e.target.value;
      console.log("value", value);
      if (value?.length >= 6) {
        dispatch(getLocationDetail(value))
          .then((data) => {
            console.log("data", data);
            formIPD.setFieldsValue({ city: data?.city, state: data?.state });
            // const { city_id, state_id } = data;
            // setCityId(city_id);
            // setStateId(state_id);
          })
          .catch((error) => {
            message.error(error);
          });
      }
    };
  return (
    <div>
      <Card>
        <Form form={formIPD} layout="vertical" onFinish={onFinishIPD}>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                label="Employee Code"
                name="employee_code"
                rules={[
                  {
                    required: true,
                    message: "Please Select Employee Code",
                  },
                ]}
              >
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Select Employee Code"
                  onChange={handleEmployeeCodeChange}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {employeeCode.map((employee) => (
                    <Option key={employee.id} value={employee.employee_code}>
                      {employee.employee_code}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                label="Patient Name"
                name="patient_name"
                rules={[
                  {
                    required: true,
                    message: "Please Select Patient Name",
                  },
                ]}
              >
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Select Patient Name"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {patientName.map((patient) => (
                    <Option key={patient.id} value={patient.employee_name}>
                      {patient.employee_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="reason_for_claim"
                label="Reason For Claim "
                rules={[
                  { required: true, message: "Please enter Reason For Claim " },
                ]}
              >
                <Input placeholder="Reason For Claim " />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Form.Item
                name="est_report_amount"
                label="Estimated / Report Amount (₹)"
                rules={[
                  {
                    required: true,
                    message: "Please enter Estimated / Report Amount (₹)",
                  },
                  {
                    // This pattern ensures the input is a valid number and disallows commas.
                    pattern: /^\d+(\.\d{1,2})?$/,
                    message: "Please enter a valid amount without commas or special characters.",
                  },
                ]}
              >
                <Input placeholder="Estimated / Report Amount (₹)" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="hospitalization_date"
                label="Hospitalization Date "
                rules={[{ required: true, message: "Please Enter Hospitalization Date" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  placeholder="DD-MM-YYYY"
                  disabledDate={(current) => current && current > dayjs().endOf("day")}
                  // FIX 3: Call the handler on change
                  onChange={handleHospitalizationDateChange}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="discharge_date"
                label="Discharge Date"
                rules={[{ required: false, message: "Please Enter Discharge Date" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  placeholder="DD-MM-YYYY"
                  // FIX 4: Implement dynamic date disabling
                  disabledDate={(current) => {
                    // Disable dates in the future
                    if (current && current > dayjs().endOf("day")) {
                      return true;
                    }
                    // Disable dates before the selected hospitalization date
                    if (hospitalizationDate && current < hospitalizationDate.startOf("day")) {
                      return true;
                    }
                    return false;
                  }}
                />
              </Form.Item>
            </Col>
            {/* The rest of your form remains the same */}
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="hospital_name"
                label="Name of the Hospital"
                rules={[
                  {
                    required: true,
                    message: "Please enter Name of the Hospital",
                  },
                ]}
              >
                <Input placeholder="Name of the Hospital" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={16} lg={16} xl={16}>
              <Form.Item
                name="hospital_address"
                label="Hospital Address"
                rules={[
                  {
                    required: true,
                    message: "Please enter Hospital Address",
                  },
                ]}
              >
                <Input placeholder="Hospital Address" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="pincode"
                label="Pincode"
                rules={[
                  {
                    required: true,
                    message: "Please enter Pincode",
                  },
                ]}
              >
               <Input
                type="text"
                onChange={OnPinChange}
                placeholder="Pincode"
              />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="city"
                label="City"
                rules={[
                  {
                    required: true,
                    message: "Please enter City",
                  },
                ]}
              >
                <Input placeholder="City" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="state"
                label="State"
                rules={[
                  {
                    required: true,
                    message: "Please enter State",
                  },
                ]}
              >
                <Input placeholder="State" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                label="Claim Type"
                name="claim_type"
                rules={[
                  {
                    required: true,
                    message: "Please Select Claim Type",
                  },
                ]}
              >
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Select Claim Type"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {ClaimType.map((insurer) => (
                    <Option key={insurer.id} value={insurer.name}>
                      {insurer.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={16} lg={16} xl={16}>
              <Form.Item
                name="remark"
                label="Remarks"
                rules={[
                  {
                    required: false,
                    message: "Please enter Remarks",
                  },
                ]}
              >
                <TextArea rows={3} placeholder="Remarks" />
              </Form.Item>
            </Col>
          </Row>
          <Button type="primary" htmlType="submit" loading={loading}>
            Intimate Claim
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default IpdForm;